/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type {
  AdviceCard,
  ConversationInput,
  ConversationMessagePagination,
  ConversationMessagesConversationMessagesGetParams,
  ConversationStarter,
  ConversationSummary,
  ConversationStreamingError,
  ConversationStreamingSuccess,
  ConversationVariableUpdateRequest,
  ConversationVariables,
  ErrorResponse,
  GenerateResponseConversationPostParams,
  GenerateResponseVoiceGeneratePostParams,
  HTTPValidationError,
  PendingMessage,
  PersistVoiceMessagesInput,
  PersistVoiceMessagesVoiceConversationPostParams,
  SpeechResponse,
  VoiceConversationInput,
  VoiceTokenInput,
} from './client.schemas';

export type defaultRouteGetResponse200 = {
  data: string;
  status: 200;
};

export type defaultRouteGetResponseSuccess = defaultRouteGetResponse200 & {
  headers: Headers;
};
export type defaultRouteGetResponse = defaultRouteGetResponseSuccess;

export const getDefaultRouteGetUrl = () => {
  return `${process.env.REACT_APP_CHAT_API_URL}/`;
};

/**
 * @summary Default Route
 */
export const defaultRouteGet = async (
  options?: RequestInit,
): Promise<defaultRouteGetResponse> => {
  const res = await fetch(getDefaultRouteGetUrl(), {
    ...options,
    method: 'GET',
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: defaultRouteGetResponse['data'] = body ? JSON.parse(body) : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as defaultRouteGetResponse;
};

export type returnVersionVersionGetResponse200 = {
  data: string;
  status: 200;
};

export type returnVersionVersionGetResponseSuccess =
  returnVersionVersionGetResponse200 & {
    headers: Headers;
  };
export type returnVersionVersionGetResponse =
  returnVersionVersionGetResponseSuccess;

export const getReturnVersionVersionGetUrl = () => {
  return `${process.env.REACT_APP_CHAT_API_URL}/version`;
};

/**
 * @summary Return Version
 */
export const returnVersionVersionGet = async (
  options?: RequestInit,
): Promise<returnVersionVersionGetResponse> => {
  const res = await fetch(getReturnVersionVersionGetUrl(), {
    ...options,
    method: 'GET',
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: returnVersionVersionGetResponse['data'] = body
    ? JSON.parse(body)
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as returnVersionVersionGetResponse;
};

export type conversationAdviceCardsConversationAdviceCardsGetResponse200 = {
  data: AdviceCard[];
  status: 200;
};

export type conversationAdviceCardsConversationAdviceCardsGetResponse401 = {
  data: ErrorResponse;
  status: 401;
};

export type conversationAdviceCardsConversationAdviceCardsGetResponse403 = {
  data: ErrorResponse;
  status: 403;
};

export type conversationAdviceCardsConversationAdviceCardsGetResponse503 = {
  data: ErrorResponse;
  status: 503;
};

export type conversationAdviceCardsConversationAdviceCardsGetResponseSuccess =
  conversationAdviceCardsConversationAdviceCardsGetResponse200 & {
    headers: Headers;
  };
export type conversationAdviceCardsConversationAdviceCardsGetResponseError = (
  | conversationAdviceCardsConversationAdviceCardsGetResponse401
  | conversationAdviceCardsConversationAdviceCardsGetResponse403
  | conversationAdviceCardsConversationAdviceCardsGetResponse503
) & {
  headers: Headers;
};

export type conversationAdviceCardsConversationAdviceCardsGetResponse =
  | conversationAdviceCardsConversationAdviceCardsGetResponseSuccess
  | conversationAdviceCardsConversationAdviceCardsGetResponseError;

export const getConversationAdviceCardsConversationAdviceCardsGetUrl = () => {
  return `${process.env.REACT_APP_CHAT_API_URL}/conversation_advice_cards`;
};

/**
 * @summary Conversation Advice Cards
 */
export const conversationAdviceCardsConversationAdviceCardsGet = async (
  options?: RequestInit,
): Promise<conversationAdviceCardsConversationAdviceCardsGetResponse> => {
  const res = await fetch(
    getConversationAdviceCardsConversationAdviceCardsGetUrl(),
    {
      ...options,
      method: 'GET',
    },
  );

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: conversationAdviceCardsConversationAdviceCardsGetResponse['data'] =
    body ? JSON.parse(body) : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as conversationAdviceCardsConversationAdviceCardsGetResponse;
};

export type conversationMessagesConversationMessagesGetResponse200 = {
  data: ConversationMessagePagination;
  status: 200;
};

export type conversationMessagesConversationMessagesGetResponse401 = {
  data: ErrorResponse;
  status: 401;
};

export type conversationMessagesConversationMessagesGetResponse403 = {
  data: ErrorResponse;
  status: 403;
};

export type conversationMessagesConversationMessagesGetResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type conversationMessagesConversationMessagesGetResponse503 = {
  data: ErrorResponse;
  status: 503;
};

export type conversationMessagesConversationMessagesGetResponseSuccess =
  conversationMessagesConversationMessagesGetResponse200 & {
    headers: Headers;
  };
export type conversationMessagesConversationMessagesGetResponseError = (
  | conversationMessagesConversationMessagesGetResponse401
  | conversationMessagesConversationMessagesGetResponse403
  | conversationMessagesConversationMessagesGetResponse422
  | conversationMessagesConversationMessagesGetResponse503
) & {
  headers: Headers;
};

export type conversationMessagesConversationMessagesGetResponse =
  | conversationMessagesConversationMessagesGetResponseSuccess
  | conversationMessagesConversationMessagesGetResponseError;

export const getConversationMessagesConversationMessagesGetUrl = (
  params?: ConversationMessagesConversationMessagesGetParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `${process.env.REACT_APP_CHAT_API_URL}/conversation_messages?${stringifiedParams}`
    : `${process.env.REACT_APP_CHAT_API_URL}/conversation_messages`;
};

/**
 * @summary Conversation Messages
 */
export const conversationMessagesConversationMessagesGet = async (
  params?: ConversationMessagesConversationMessagesGetParams,
  options?: RequestInit,
): Promise<conversationMessagesConversationMessagesGetResponse> => {
  const res = await fetch(
    getConversationMessagesConversationMessagesGetUrl(params),
    {
      ...options,
      method: 'GET',
    },
  );

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: conversationMessagesConversationMessagesGetResponse['data'] = body
    ? JSON.parse(body)
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as conversationMessagesConversationMessagesGetResponse;
};

export type generateResponseConversationPostResponse200 = {
  data: ConversationStreamingSuccess | ConversationStreamingError;
  status: 200;
};

export type generateResponseConversationPostResponse401 = {
  data: ErrorResponse;
  status: 401;
};

export type generateResponseConversationPostResponse403 = {
  data: ErrorResponse;
  status: 403;
};

export type generateResponseConversationPostResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type generateResponseConversationPostResponse503 = {
  data: ErrorResponse;
  status: 503;
};

export type generateResponseConversationPostResponseSuccess =
  generateResponseConversationPostResponse200 & {
    headers: Headers;
  };
export type generateResponseConversationPostResponseError = (
  | generateResponseConversationPostResponse401
  | generateResponseConversationPostResponse403
  | generateResponseConversationPostResponse422
  | generateResponseConversationPostResponse503
) & {
  headers: Headers;
};

export type generateResponseConversationPostResponse =
  | generateResponseConversationPostResponseSuccess
  | generateResponseConversationPostResponseError;

export const getGenerateResponseConversationPostUrl = (
  params?: GenerateResponseConversationPostParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `${process.env.REACT_APP_CHAT_API_URL}/conversation?${stringifiedParams}`
    : `${process.env.REACT_APP_CHAT_API_URL}/conversation`;
};

/**
 * @summary Generate Response
 */
export const generateResponseConversationPost = async (
  conversationInput: ConversationInput,
  params?: GenerateResponseConversationPostParams,
  options?: RequestInit,
): Promise<generateResponseConversationPostResponse> => {
  const res = await fetch(getGenerateResponseConversationPostUrl(params), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(conversationInput),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: generateResponseConversationPostResponse['data'] = body
    ? JSON.parse(body)
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as generateResponseConversationPostResponse;
};

export type clearConversationHistoryConversationClearPostResponse200 = {
  data: unknown;
  status: 200;
};

export type clearConversationHistoryConversationClearPostResponse401 = {
  data: ErrorResponse;
  status: 401;
};

export type clearConversationHistoryConversationClearPostResponse403 = {
  data: ErrorResponse;
  status: 403;
};

export type clearConversationHistoryConversationClearPostResponse503 = {
  data: ErrorResponse;
  status: 503;
};

export type clearConversationHistoryConversationClearPostResponseSuccess =
  clearConversationHistoryConversationClearPostResponse200 & {
    headers: Headers;
  };
export type clearConversationHistoryConversationClearPostResponseError = (
  | clearConversationHistoryConversationClearPostResponse401
  | clearConversationHistoryConversationClearPostResponse403
  | clearConversationHistoryConversationClearPostResponse503
) & {
  headers: Headers;
};

export type clearConversationHistoryConversationClearPostResponse =
  | clearConversationHistoryConversationClearPostResponseSuccess
  | clearConversationHistoryConversationClearPostResponseError;

export const getClearConversationHistoryConversationClearPostUrl = () => {
  return `${process.env.REACT_APP_CHAT_API_URL}/conversation/clear`;
};

/**
 * @summary Clear Conversation History
 */
export const clearConversationHistoryConversationClearPost = async (
  options?: RequestInit,
): Promise<clearConversationHistoryConversationClearPostResponse> => {
  const res = await fetch(
    getClearConversationHistoryConversationClearPostUrl(),
    {
      ...options,
      method: 'POST',
    },
  );

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: clearConversationHistoryConversationClearPostResponse['data'] =
    body ? JSON.parse(body) : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as clearConversationHistoryConversationClearPostResponse;
};

export type getConversationVariablesConversationVariablesGetResponse200 = {
  data: ConversationVariables;
  status: 200;
};

export type getConversationVariablesConversationVariablesGetResponse401 = {
  data: ErrorResponse;
  status: 401;
};

export type getConversationVariablesConversationVariablesGetResponse403 = {
  data: ErrorResponse;
  status: 403;
};

export type getConversationVariablesConversationVariablesGetResponse503 = {
  data: ErrorResponse;
  status: 503;
};

export type getConversationVariablesConversationVariablesGetResponseSuccess =
  getConversationVariablesConversationVariablesGetResponse200 & {
    headers: Headers;
  };
export type getConversationVariablesConversationVariablesGetResponseError = (
  | getConversationVariablesConversationVariablesGetResponse401
  | getConversationVariablesConversationVariablesGetResponse403
  | getConversationVariablesConversationVariablesGetResponse503
) & {
  headers: Headers;
};

export type getConversationVariablesConversationVariablesGetResponse =
  | getConversationVariablesConversationVariablesGetResponseSuccess
  | getConversationVariablesConversationVariablesGetResponseError;

export const getGetConversationVariablesConversationVariablesGetUrl = () => {
  return `${process.env.REACT_APP_CHAT_API_URL}/conversation/variables`;
};

/**
 * @summary Get Conversation Variables
 */
export const getConversationVariablesConversationVariablesGet = async (
  options?: RequestInit,
): Promise<getConversationVariablesConversationVariablesGetResponse> => {
  const res = await fetch(
    getGetConversationVariablesConversationVariablesGetUrl(),
    {
      ...options,
      method: 'GET',
    },
  );

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getConversationVariablesConversationVariablesGetResponse['data'] =
    body ? JSON.parse(body) : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as getConversationVariablesConversationVariablesGetResponse;
};

export type updateConversationVariablesConversationVariablesPatchResponse200 = {
  data: unknown;
  status: 200;
};

export type updateConversationVariablesConversationVariablesPatchResponse401 = {
  data: ErrorResponse;
  status: 401;
};

export type updateConversationVariablesConversationVariablesPatchResponse403 = {
  data: ErrorResponse;
  status: 403;
};

export type updateConversationVariablesConversationVariablesPatchResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type updateConversationVariablesConversationVariablesPatchResponse503 = {
  data: ErrorResponse;
  status: 503;
};

export type updateConversationVariablesConversationVariablesPatchResponseSuccess =
  updateConversationVariablesConversationVariablesPatchResponse200 & {
    headers: Headers;
  };
export type updateConversationVariablesConversationVariablesPatchResponseError =
  (
    | updateConversationVariablesConversationVariablesPatchResponse401
    | updateConversationVariablesConversationVariablesPatchResponse403
    | updateConversationVariablesConversationVariablesPatchResponse422
    | updateConversationVariablesConversationVariablesPatchResponse503
  ) & {
    headers: Headers;
  };

export type updateConversationVariablesConversationVariablesPatchResponse =
  | updateConversationVariablesConversationVariablesPatchResponseSuccess
  | updateConversationVariablesConversationVariablesPatchResponseError;

export const getUpdateConversationVariablesConversationVariablesPatchUrl =
  () => {
    return `${process.env.REACT_APP_CHAT_API_URL}/conversation/variables`;
  };

/**
 * @summary Update Conversation Variables
 */
export const updateConversationVariablesConversationVariablesPatch = async (
  conversationVariableUpdateRequest: ConversationVariableUpdateRequest,
  options?: RequestInit,
): Promise<updateConversationVariablesConversationVariablesPatchResponse> => {
  const res = await fetch(
    getUpdateConversationVariablesConversationVariablesPatchUrl(),
    {
      ...options,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(conversationVariableUpdateRequest),
    },
  );

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: updateConversationVariablesConversationVariablesPatchResponse['data'] =
    body ? JSON.parse(body) : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as updateConversationVariablesConversationVariablesPatchResponse;
};

export type generateVoiceTokenVoiceTokenPostResponse200 = {
  data: string;
  status: 200;
};

export type generateVoiceTokenVoiceTokenPostResponse401 = {
  data: ErrorResponse;
  status: 401;
};

export type generateVoiceTokenVoiceTokenPostResponse403 = {
  data: ErrorResponse;
  status: 403;
};

export type generateVoiceTokenVoiceTokenPostResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type generateVoiceTokenVoiceTokenPostResponse503 = {
  data: ErrorResponse;
  status: 503;
};

export type generateVoiceTokenVoiceTokenPostResponseSuccess =
  generateVoiceTokenVoiceTokenPostResponse200 & {
    headers: Headers;
  };
export type generateVoiceTokenVoiceTokenPostResponseError = (
  | generateVoiceTokenVoiceTokenPostResponse401
  | generateVoiceTokenVoiceTokenPostResponse403
  | generateVoiceTokenVoiceTokenPostResponse422
  | generateVoiceTokenVoiceTokenPostResponse503
) & {
  headers: Headers;
};

export type generateVoiceTokenVoiceTokenPostResponse =
  | generateVoiceTokenVoiceTokenPostResponseSuccess
  | generateVoiceTokenVoiceTokenPostResponseError;

export const getGenerateVoiceTokenVoiceTokenPostUrl = () => {
  return `${process.env.REACT_APP_CHAT_API_URL}/voice/token`;
};

/**
 * @summary Generate Voice Token
 */
export const generateVoiceTokenVoiceTokenPost = async (
  voiceTokenInput?: VoiceTokenInput,
  options?: RequestInit,
): Promise<generateVoiceTokenVoiceTokenPostResponse> => {
  const res = await fetch(getGenerateVoiceTokenVoiceTokenPostUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(voiceTokenInput),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: generateVoiceTokenVoiceTokenPostResponse['data'] = body
    ? JSON.parse(body)
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as generateVoiceTokenVoiceTokenPostResponse;
};

export type generateResponseVoiceGeneratePostResponse200 = {
  data: SpeechResponse;
  status: 200;
};

export type generateResponseVoiceGeneratePostResponse401 = {
  data: ErrorResponse;
  status: 401;
};

export type generateResponseVoiceGeneratePostResponse403 = {
  data: ErrorResponse;
  status: 403;
};

export type generateResponseVoiceGeneratePostResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type generateResponseVoiceGeneratePostResponse503 = {
  data: ErrorResponse;
  status: 503;
};

export type generateResponseVoiceGeneratePostResponseSuccess =
  generateResponseVoiceGeneratePostResponse200 & {
    headers: Headers;
  };
export type generateResponseVoiceGeneratePostResponseError = (
  | generateResponseVoiceGeneratePostResponse401
  | generateResponseVoiceGeneratePostResponse403
  | generateResponseVoiceGeneratePostResponse422
  | generateResponseVoiceGeneratePostResponse503
) & {
  headers: Headers;
};

export type generateResponseVoiceGeneratePostResponse =
  | generateResponseVoiceGeneratePostResponseSuccess
  | generateResponseVoiceGeneratePostResponseError;

export const getGenerateResponseVoiceGeneratePostUrl = (
  params?: GenerateResponseVoiceGeneratePostParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `${process.env.REACT_APP_CHAT_API_URL}/voice/generate?${stringifiedParams}`
    : `${process.env.REACT_APP_CHAT_API_URL}/voice/generate`;
};

/**
 * @summary Generate Response
 */
export const generateResponseVoiceGeneratePost = async (
  voiceConversationInput: VoiceConversationInput,
  params?: GenerateResponseVoiceGeneratePostParams,
  options?: RequestInit,
): Promise<generateResponseVoiceGeneratePostResponse> => {
  const res = await fetch(getGenerateResponseVoiceGeneratePostUrl(params), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(voiceConversationInput),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: generateResponseVoiceGeneratePostResponse['data'] = body
    ? JSON.parse(body)
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as generateResponseVoiceGeneratePostResponse;
};

export type persistVoiceMessagesVoiceConversationPostResponse200 = {
  data: unknown;
  status: 200;
};

export type persistVoiceMessagesVoiceConversationPostResponse401 = {
  data: ErrorResponse;
  status: 401;
};

export type persistVoiceMessagesVoiceConversationPostResponse403 = {
  data: ErrorResponse;
  status: 403;
};

export type persistVoiceMessagesVoiceConversationPostResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type persistVoiceMessagesVoiceConversationPostResponse503 = {
  data: ErrorResponse;
  status: 503;
};

export type persistVoiceMessagesVoiceConversationPostResponseSuccess =
  persistVoiceMessagesVoiceConversationPostResponse200 & {
    headers: Headers;
  };
export type persistVoiceMessagesVoiceConversationPostResponseError = (
  | persistVoiceMessagesVoiceConversationPostResponse401
  | persistVoiceMessagesVoiceConversationPostResponse403
  | persistVoiceMessagesVoiceConversationPostResponse422
  | persistVoiceMessagesVoiceConversationPostResponse503
) & {
  headers: Headers;
};

export type persistVoiceMessagesVoiceConversationPostResponse =
  | persistVoiceMessagesVoiceConversationPostResponseSuccess
  | persistVoiceMessagesVoiceConversationPostResponseError;

export const getPersistVoiceMessagesVoiceConversationPostUrl = (
  params?: PersistVoiceMessagesVoiceConversationPostParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `${process.env.REACT_APP_CHAT_API_URL}/voice/conversation?${stringifiedParams}`
    : `${process.env.REACT_APP_CHAT_API_URL}/voice/conversation`;
};

/**
 * @summary Persist Voice Messages
 */
export const persistVoiceMessagesVoiceConversationPost = async (
  persistVoiceMessagesInput: PersistVoiceMessagesInput,
  params?: PersistVoiceMessagesVoiceConversationPostParams,
  options?: RequestInit,
): Promise<persistVoiceMessagesVoiceConversationPostResponse> => {
  const res = await fetch(
    getPersistVoiceMessagesVoiceConversationPostUrl(params),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(persistVoiceMessagesInput),
    },
  );

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: persistVoiceMessagesVoiceConversationPostResponse['data'] = body
    ? JSON.parse(body)
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as persistVoiceMessagesVoiceConversationPostResponse;
};

export type conversationStartersConversationStartersGetResponse200 = {
  data: ConversationStarter[];
  status: 200;
};

export type conversationStartersConversationStartersGetResponse401 = {
  data: ErrorResponse;
  status: 401;
};

export type conversationStartersConversationStartersGetResponse403 = {
  data: ErrorResponse;
  status: 403;
};

export type conversationStartersConversationStartersGetResponse503 = {
  data: ErrorResponse;
  status: 503;
};

export type conversationStartersConversationStartersGetResponseSuccess =
  conversationStartersConversationStartersGetResponse200 & {
    headers: Headers;
  };
export type conversationStartersConversationStartersGetResponseError = (
  | conversationStartersConversationStartersGetResponse401
  | conversationStartersConversationStartersGetResponse403
  | conversationStartersConversationStartersGetResponse503
) & {
  headers: Headers;
};

export type conversationStartersConversationStartersGetResponse =
  | conversationStartersConversationStartersGetResponseSuccess
  | conversationStartersConversationStartersGetResponseError;

export const getConversationStartersConversationStartersGetUrl = () => {
  return `${process.env.REACT_APP_CHAT_API_URL}/conversation_starters`;
};

/**
 * @summary Conversation Starters
 */
export const conversationStartersConversationStartersGet = async (
  options?: RequestInit,
): Promise<conversationStartersConversationStartersGetResponse> => {
  const res = await fetch(getConversationStartersConversationStartersGetUrl(), {
    ...options,
    method: 'GET',
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: conversationStartersConversationStartersGetResponse['data'] = body
    ? JSON.parse(body)
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as conversationStartersConversationStartersGetResponse;
};

export type getConversationSummaryConversationSummaryGetResponse200 = {
  data: ConversationSummary;
  status: 200;
};

export type getConversationSummaryConversationSummaryGetResponse401 = {
  data: ErrorResponse;
  status: 401;
};

export type getConversationSummaryConversationSummaryGetResponse403 = {
  data: ErrorResponse;
  status: 403;
};

export type getConversationSummaryConversationSummaryGetResponse503 = {
  data: ErrorResponse;
  status: 503;
};

export type getConversationSummaryConversationSummaryGetResponseSuccess =
  getConversationSummaryConversationSummaryGetResponse200 & {
    headers: Headers;
  };
export type getConversationSummaryConversationSummaryGetResponseError = (
  | getConversationSummaryConversationSummaryGetResponse401
  | getConversationSummaryConversationSummaryGetResponse403
  | getConversationSummaryConversationSummaryGetResponse503
) & {
  headers: Headers;
};

export type getConversationSummaryConversationSummaryGetResponse =
  | getConversationSummaryConversationSummaryGetResponseSuccess
  | getConversationSummaryConversationSummaryGetResponseError;

export const getGetConversationSummaryConversationSummaryGetUrl = () => {
  return `${process.env.REACT_APP_CHAT_API_URL}/conversation_summary`;
};

/**
 * @summary Get Conversation Summary
 */
export const getConversationSummaryConversationSummaryGet = async (
  options?: RequestInit,
): Promise<getConversationSummaryConversationSummaryGetResponse> => {
  const res = await fetch(
    getGetConversationSummaryConversationSummaryGetUrl(),
    {
      ...options,
      method: 'GET',
    },
  );

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getConversationSummaryConversationSummaryGetResponse['data'] =
    body ? JSON.parse(body) : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as getConversationSummaryConversationSummaryGetResponse;
};

export type getPendingMessagePendingMessageGetResponse200 = {
  data: PendingMessage;
  status: 200;
};

export type getPendingMessagePendingMessageGetResponse401 = {
  data: ErrorResponse;
  status: 401;
};

export type getPendingMessagePendingMessageGetResponse403 = {
  data: ErrorResponse;
  status: 403;
};

export type getPendingMessagePendingMessageGetResponse503 = {
  data: ErrorResponse;
  status: 503;
};

export type getPendingMessagePendingMessageGetResponseSuccess =
  getPendingMessagePendingMessageGetResponse200 & {
    headers: Headers;
  };
export type getPendingMessagePendingMessageGetResponseError = (
  | getPendingMessagePendingMessageGetResponse401
  | getPendingMessagePendingMessageGetResponse403
  | getPendingMessagePendingMessageGetResponse503
) & {
  headers: Headers;
};

export type getPendingMessagePendingMessageGetResponse =
  | getPendingMessagePendingMessageGetResponseSuccess
  | getPendingMessagePendingMessageGetResponseError;

export const getGetPendingMessagePendingMessageGetUrl = () => {
  return `${process.env.REACT_APP_CHAT_API_URL}/pending_message`;
};

/**
 * @summary Get Pending Message
 */
export const getPendingMessagePendingMessageGet = async (
  options?: RequestInit,
): Promise<getPendingMessagePendingMessageGetResponse> => {
  const res = await fetch(getGetPendingMessagePendingMessageGetUrl(), {
    ...options,
    method: 'GET',
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getPendingMessagePendingMessageGetResponse['data'] = body
    ? JSON.parse(body)
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as getPendingMessagePendingMessageGetResponse;
};
